import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { BookingInfo } from './types';

type GetBookingListArgs = {
  bookingId: string;
};

type GetBookingListResponse = {
  state: number;
  value: BookingInfo[];
};

export const getBookingList = async ({
  bookingId,
}: GetBookingListArgs): Promise<BookingInfo[]> => {
  try {
    const res = await apiClient.post<GetBookingListResponse>(
      Endpoints.BookingList,
      {
        booking: bookingId,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
